import { createContext } from "react";

export const AppearanceContext = createContext(null);